// Self-executing font loader for HTML consumers (dist/font-loader.js).
//
// @martinus/fonts exports loadFonts() as an ES module for bundler consumers
// (Storybook waits on document.fonts instead), but an HTML consumer needs a
// plain <script src> - a cross-origin ES module import would additionally be
// CORS-gated. This boot wraps the same loader as an IIFE and derives the font
// directory from its own URL: the script is served at
// <base>/scripts/font-loader.js and the binaries at
// <base>/fonts/Tabac-Sans/fonts/, so no configuration is needed.
//
// document.currentScript is null for async/module execution contexts, but
// this bundle is a classic synchronous script, so it is always set here; the
// guard only covers exotic embedding (e.g. injected via eval), falling back
// to loadFonts' own same-origin default path.
import loadFonts from '@martinus/fonts';

const script = document.currentScript as HTMLScriptElement | null;
loadFonts(script?.src ? new URL('../fonts/Tabac-Sans/fonts/', script.src).href : undefined);
